import useSound from "use-sound";
import { useGetOrderMediaConfig } from "../../PlaceOrderTest/queryHooks";
import { ChatType } from "../../../types/chatTypes";

export const useChatNotificationSound = () => {
  const { data: mobileConfigs } = useGetOrderMediaConfig();
  const supplierSoundUrl = mobileConfigs?.chat_notification_sound_orca_supplier;
  const customerSoundUrl = (mobileConfigs as any)
    ?.chat_notification_sound_orca_customer;

  const [playSupplierNotificationSound] = useSound(supplierSoundUrl, {
    volume: 1,
    preload: true,
    html5: true,
    soundEnabled: !!supplierSoundUrl,
    id: "supplier-notification",
  });

  const [playCustomerNotificationSound] = useSound(customerSoundUrl, {
    volume: 1,
    preload: true,
    html5: true,
    soundEnabled: !!customerSoundUrl,
    id: "customer-notification",
  });

  const playSound = (chatType?: string) => {
    try {
      if (chatType === ChatType.CUSTOMER) {
        playCustomerNotificationSound();
      } else {
        playSupplierNotificationSound();
      }
    } catch (error) {
      console.error("Failed to play chat notification sound:", error);
    }
  };

  return playSound;
};
